import type { FC } from "react";
import { hrisMappingPunchEventTypeIgnoreSortingKey } from "../../../../../services/LocalStorageService";
import { HrisIgnoreCategory } from "../../../../../utils/models";
import { IgnoredValueListGrid } from "./IgnoredValueListGrid";

export const PunchEventTypeIgnoreGrid: FC = () => (
	<IgnoredValueListGrid
		category={HrisIgnoreCategory.PunchEventType}
		addButtonLabelKey="hris.mapping.ignored.addPunchEventType"
		addDialogTitleKey="hris.mapping.ignored.add.dialog.titlePunchEventType"
		searchPlaceholderKey="hris.mapping.ignored.search.placeholder"
		localStorageKey={hrisMappingPunchEventTypeIgnoreSortingKey}
		dataTestId="hris-mapping-punch-event-type-ignore"
	/>
);
